import React from 'react';
import { InputAdornment as MuiInputAdornment } from '@material-ui/core';

const InputAdornment = props => <MuiInputAdornment {...props} />;

export default InputAdornment;
